import {SimplePresentation, SimplePresentationRunnerController} from "../../core/presentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {ExtendedGameModel} from "../server/ExtendedGameModel";
import {HOTB} from "../HOTB";
import {HOTBData, HOTBGameData} from "../server/HOTBData";
import {ExtendedGameMode} from "../server/ExtendedGameMode";
import {GameUtils} from "../utils/GameUtils";
import {GameSounds} from "../sound/GameSounds";

export class PreBigWinPresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline;
    private _animName: string = "";

    shouldRun(): boolean {
        const gameModel: ExtendedGameModel = HOTB.model,
            hotbData: HOTBData = gameModel.data,
            nextMode: string = hotbData.nextMode,
            gameData: HOTBGameData = gameModel.gameData,
            brokeTheBank: boolean = gameData.brokeTheBank;

        let flag: boolean = false;

        if (gameModel.winRatio >= 15 && !brokeTheBank && !GameUtils.isSingleWinBelowStake()) {
            if (nextMode === ExtendedGameMode.NORMAL ||
                nextMode === ExtendedGameMode.FREESPIN ||
                nextMode === ExtendedGameMode.FREESPIN_SUPER) {
                flag = true;
            }
        }

        return flag;
    }

    public start(controller: SimplePresentationRunnerController): void {
        let preBigWinSound: string = "";
        if(this._animName.includes("2") || this._animName.length === 0){
            this._animName = "animation";
            preBigWinSound = GameSounds.PRE_BIG_WIN;
        } else {
            this._animName = "animation2";
            preBigWinSound = GameSounds.PRE_BIG_WIN_2;
        }

        this._mainTl = gsap.timeline({
            delay: 0.4,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add((): void => {
            controller.setSkipCallback((): void => {
                this.onSkip();
            });
        }, 0.001);

        this._mainTl.add((): void => {
            HOTB.soundPlayer.fadeMusic(0.02, 0.01);
            if (HOTB.model.gameData.featureBuyName === "SATAN_SPINS") {
                HOTB.soundPlayer.stopLoopEffect(HOTB.soundPlayer.satanSpinSoundPlaying);
                HOTB.soundPlayer.satanSpinSoundPlaying = "";
            }
        }, 0);

        this._mainTl.add(HOTB.preBigWinView.playPreBigWin(this._animName));
        this._mainTl.add((): void => {
            HOTB.soundPlayer.playSound(preBigWinSound);
        }, 0.1);

        this._mainTl.to(this, {
            duration: 0.85,
        });
    }

    private onSkip(): void {
        this._mainTl.progress(1);
    }
}